import { createLocalStorageManager, LocalStore } from 'shared/helpers/Store';
import { DispatcherDTO } from './DispatcherDTO';

export const DISPATCHER_PROFILE = 'dispatcher_profile';

export function dispatcherProfileStorageKey(guid: string): string {
  return `${DISPATCHER_PROFILE}:${guid}`;
}

export function getDispatcherProfileStore(guid: string) {
  return createLocalStorageManager<DispatcherDTO>(
    dispatcherProfileStorageKey(guid),
  );
}

export function ignoreFlatDispatcherProfileCache(): void {
  LocalStore.delete(DISPATCHER_PROFILE);
}

export function persistDispatcherProfile(
  dispatcher: DispatcherDTO & { guid: string },
  expires: number,
): void {
  ignoreFlatDispatcherProfileCache();

  getDispatcherProfileStore(dispatcher.guid).set(dispatcher, expires);
}

export function deleteDispatcherProfileCache(guid: string): void {
  ignoreFlatDispatcherProfileCache();

  getDispatcherProfileStore(guid).delete();
}
